import { useQuery } from '@apollo/client'
import { GET_INTERIOR } from '../graphql/interactive-interior'

/**
 * @param {string} clientName
 * @param {number} interiorId
 * @param {import('@apollo/client').QueryHookOptions} opts
 */
export default function useInteriorById(clientName, interiorId, opts) {
  const { data, loading, error } = useQuery(GET_INTERIOR, {
    ...opts,
    variables: {
      ...opts?.variables,
      clientName,
      interiorId,
    },
  })

  return { interior: data?.activeInterior, loading, error }
}
